import { FormInterface } from "../App";

export const showThankYouFor = (thankYouFor: string, values: FormInterface) => {
  switch (thankYouFor) {
    case "deine Hilfe":
      return ["Bekannte", "Kollegen", "Freunde"].includes(values.relationship);
    case "deine Arbeit":
      return ["Bekannte", "Kollegen"].includes(values.relationship);
    case "deinen Ratschlag":
      return ["Bekannte"].includes(values.relationship);
    case "deine Einladung":
      return ["Bekannte", "Familie"].includes(values.relationship);
    case "deine Vertretung":
      return ["Kollegen"].includes(values.relationship);
    case "deine Zeit":
      return ["Freunde"].includes(values.relationship);
    case "dein offenes Ohr":
      return ["Freunde"].includes(values.relationship);
    case "deine Loyalität":
      return ["Freunde"].includes(values.relationship);
    case "die kleinen Dinge":
      return ["Verliebte"].includes(values.relationship);
    case "deine Liebe":
      return ["Verliebte"].includes(values.relationship);
    case "deine Vergebung":
      return ["Verliebte"].includes(values.relationship);
    case "deine Unterstützung":
      return ["Familie"].includes(values.relationship);
    case "deine Fürsorge":
      return ["Familie"].includes(values.relationship);
    case "das Paketeannehmen":
      return ["Nachbarn"].includes(values.relationship);
    case "das Blumengießen":
      return ["Nachbarn"].includes(values.relationship);
    case "die Einladung":
      return ["Nachbarn"].includes(values.relationship);

    case "Dich!":
      return true;
    default:
      return false;
  }
};
